<template>
  <!-- <span class="svg-icon align_middle" @click="$emit('click')"> -->
  <svg class="svg-icon" :width="iconSize" :height="iconHeight" aria-hidden="true">
    <use :xlink:href="iconName"></use>
  </svg>
  <!-- </span> -->
</template>

<script>
export default {
  name: "SvgIcon",
  props: {
    iconClass: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      default: 14,
    },
    height: {
      type: Number,
    },
  },
  computed: {
    iconName() {
      return `#icon-${this.iconClass}`;
    },
    iconSize() {
      return this.size;
    },
    iconHeight() {
      let height = this.size || 14;
      if (this.height) {
        height = this.height;
      }
      return height;
    },
  },
};
</script>
<style lang="scss" scoped>
.svg-icon {
  // display: inline;
  line-height: 1;
  display: inline-block;
  vertical-align: middle;
}
</style>
